<template>
    <!-- Verify Report Hash popup modal -->
    <v-dialog class="v-dialog" v-model="utils.show_popup" width="450">
        <v-card class="pb-2 report-modal">

            <!-- Verify Report content -->
            <div class="p-8 pb-9 pt-3" v-if="utils.verify_report">
                <div @click="closePopup()" class="closeIcon-container">
                    <img alt="close" class="close-icon" src="/media/misc/close.png">
                </div>
                <div class="text-center">
                    <div class="custom-title pt-7">Verify Report</div>
                    <div class="custom-subheading pt-3" style="width: auto;">
                        Upload any report and verify if it’s on the blockchain
                    </div>
                    <div class="upload-verify-wrapper mt-10">
                        <img alt="cloud" src="/media/misc/cloud-upload.png" width="60px"/>

                        <!-- Custom bootstrap upload file-->
                        <label class="file-upload btn btn-upload btn-success mt-5 font-weight-bolder font-size-sm"
                               for="fileUpload">
                            Upload
                            <input @change="onUpload" id="fileUpload" type="file">
                        </label>
                        <!-- End -->

                        <label class="pt-2 font-small text-primary">(up to 10MB)</label>
                        <div class="btn btn-faded-xx mt-5 font-weight-bolder font-size-sm">
                            Only PDF is supported
                        </div>
                    </div>
                </div>
                <div style="padding-top: 1.9rem !important;">
                    <div class="upload-container progress-container-success" ref="upload_container"
                         style="display: none">
                        <div class="progress-features" style="width: auto;">

                            <div class="progress-compile-iconWrapper">
                                <i class="mdi mdi-file-pdf-outline progress-compile-icon-fade"></i>
                            </div>

                            <div class="progress-compile-dataWrapper position-relative">

                                <div class="upload-info">{{ swap.upload_title }}</div>

                                <div class="progress-compile-percent text-primary"
                                     style="right: 20px; font-size: 10px;"> Cancel
                                </div>

                                <div class="progress progress-xs w-100">
                                    <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="50"
                                         class="progress-bar bg-faded"
                                         role="progressbar" style="width: 0%;"></div>
                                </div>
                                <div class="peecent-state--Wrapper text-primary">
                                    %0 Uploading...
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center pt-10">
                    <div class="url-container" style="padding-left: 11px;">
                        <input class="input-Report--hash"
                               placeholder="Enter the blockchain hash of the report"
                               style="padding-right: 11px;" v-model.trim="$v.swap.report_hash.$model"/>
                        <div class="error_field text-left" v-if="!$v.swap.report_hash.required">Field is required</div>
                        <div class="error_field text-left" v-if="!$v.swap.report_hash.maxLength">
                            Report hash is invalid
                        </div>
                    </div>
                    <button :class="{'disabled': utils.report_verifying}"
                            @click="verifyReport()"
                            class="mt-9 btn btn-success font-weight-bold custom-btn-create-report">
                        Verify Report
                    </button>
                </div>
            </div>
            <!-- Verify Report content -->

            <!-- Report Verified content -->
            <div class="p-8 pb-9 pt-3" v-if="utils.report_verified">
                <div @click="closePopup()" class="closeIcon-container">
                    <img alt="close" class="close-icon" src="/media/misc/close.png">
                </div>
                <div class="text-center">
                    <div class="custom-title pt-7">Report Found</div>
                    <div class="custom-subheading pt-3" style="width: auto;">
                        This is a valid report which was uploaded to the Ethereum blockchain
                    </div>
                    <div class="report-verified-wrapper mt-10">
                        <img alt="report" src="/media/misc/report-found.png" width="80px"/>
                    </div>
                </div>
                <div style="padding-top: 2.5rem !important;">
                    <div class="container">
                        <div class="font-min-small pb-3">Date and time of upload</div>
                        <div class="row">
                            <div class="col-6">
                                <div class="upload-time-container">
                                    <span>{{ swap.report_found.date_time | date }}</span>
                                    <i class=" mdi mdi-calendar-month pl-2"
                                       style="font-size: 20px;position: absolute;color: #44566C;"></i>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="upload-time-container">
                                    <span>{{ swap.report_found.date_time | time }}</span>
                                    <i class=" mdi mdi-clock-outline pl-2"
                                       style="font-size: 20px;position: absolute;color: #44566C;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="container pt-8">
                        <div class="font-min-small pb-3">Link to report hash on Blockchain</div>
                        <div class="row">
                            <div class="col-12">
                                <a :href="swap.report_found.hash" class="custom-href font-weight-bold d-block"
                                   target="_blank">
                                    {{swap.report_found.hash}}
                                    <i class=" mdi mdi-open-in-new pl-1"
                                       style="font-size: 13px; position: relative; top: 3px; color: inherit;"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center pt-10">
                    <button @click="resetVerifyReport()"
                            class="mt-9 btn btn-success font-weight-bold custom-btn-create-report">
                        Verify Another Report
                    </button>
                </div>
            </div>
            <!-- Report Verified content -->

            <!-- Report Not Found content -->
            <div class="p-8 pb-9 pt-3" v-if="utils.report_not_found">
                <div @click="closePopup()" class="closeIcon-container">
                    <img alt="close" class="close-icon" src="/media/misc/close.png">
                </div>
                <div class="text-center">
                    <div class="custom-title pt-7">Report Hash not found</div>
                    <div class="custom-subheading pt-3" style="width: auto;">
                        This is an invalid report which was not uploaded to the Etheruem blockchain
                    </div>
                    <div class="report-unverified-wrapper mt-10">
                        <img alt="report" src="/media/misc/report-not-found.png" width="80px"/>
                    </div>
                </div>
                <div class="text-center pt-10">
                    <button @click="resetVerifyReport()"
                            class="mt-9 btn btn-success font-weight-bold custom-btn-create-report">
                        Verify Another Report
                    </button>
                </div>
            </div>
            <!-- Report Not Found content -->

        </v-card>
    </v-dialog>
    <!-- Verify Report Hash popup modal -->
</template>

<script>

   import {bus} from '../../../main';
   import timerMixin from '../../../core/mixins/timerMixin';
   import generalMixin from '../../../core/mixins/generalMixin';
   import {required, maxLength} from 'vuelidate/lib/validators';
   import {validationMixin} from 'vuelidate';
   import {VERIFY_REPORT_HASH} from '../../../core/store/modules/report';

   export default {
      name: "VerifyReportPopup",
      data() {
         return {
            utils: {
               show_popup: false,
               verify_report: true,
               report_verified: false,
               report_verifying: false,
               report_not_found: false,
               is_report_hash_valid: false,
            },
            swap: {
               report_hash: '',
               report_found: {
                  hash: '',
                  date_time: ''
               }
            },
         }
      },
      validations: {
         swap: {
            report_hash: {
               required,
               maxLength: maxLength(25)
            }
         },
      },
      mixins: [timerMixin, generalMixin, validationMixin],
      methods: {
         closePopup() {
            this.utils.show_popup = false;
         },
         verifyReport() {
            if (this.$v.swap.report_hash.required && this.$v.swap.report_hash.maxLength && this.swap.upload_title.length) {
               this.utils.report_verifying = true;
               setTimeout(() => {
                  this.$store.dispatch(VERIFY_REPORT_HASH, this.swap.report_hash).then((res) => {
                     this.utils.report_verifying = false;
                     if (res.response['_transactionHash']) {
                        this.utils.verify_report = false;
                        this.utils.report_not_found = false;
                        this.utils.report_verified = true;
                        this.swap.report_found = {
                           hash: `https://ropsten.etherscan.io/tx/${res.response._transactionHash}`,
                           date_time: new Date(res.response._timestamp * 1000),
                        }
                     } else {
                        this.utils.verify_report = false;
                        this.utils.report_verified = false;
                        this.utils.report_not_found = true;
                     }
                  }).catch((err) => {
                     this.utils.report_verifying = false;
                  })
               }, 1000);
            }
         },
         onUpload(event) {
            if (event.target.files[0].name) {
               this.swap.upload_title = event.target.files[0].name;
               this.startUploading();
            }
         },
         resetVerifyReport() {
            this.utils.verify_report = true;
            this.utils.report_not_found = false;
            this.utils.report_verified = false;
            this.swap.report_hash = '';
            this.swap.upload_title = '';
         }
      },
      mounted() {
         bus.$on('open_report_popup', (data) => {
            this.resetUpload();
            this.resetVerifyReport();
            this.utils.show_popup = true;

            // wait for few secs so the popup can fully displayed
            setTimeout(() => {
               if (data) {
                  this.swap.upload_title = data.captured_file_id + '.pdf';
                  this.swap.report_hash = data.captured_file_hash;
                  this.startUploading();
               }
            }, 500);
         });
      }
   }
</script>

<style scoped>
    .error_field {
        color: red;
        font-size: 10px;
    }

    .disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }

    .file-upload input[type='file'] {
        display: none;
    }
</style>